// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__20iE_","modalFooterButton":"ModalNotes_modalFooterButton__3NFgZ"};